type ComposerFocusTarget = {
    isTitleComposer: boolean
    focus: () => void
}

type Schedule = (callback: () => void, delay: number) => unknown

const FIRST_REPLY_FOCUS_DELAYS_MS = [0, 80, 180, 400]

export function scheduleFirstReplyFocus(
    getCurrentComposer: () => ComposerFocusTarget | null | undefined,
    schedule: Schedule = setTimeout,
): void {
    const focusReplyIfReady = () => {
        const composer = getCurrentComposer()
        if (!composer || composer.isTitleComposer) return

        composer.focus()
    }

    FIRST_REPLY_FOCUS_DELAYS_MS.forEach(delay => schedule(focusReplyIfReady, delay))
}
